import React, { useState } from 'react'
import { Button } from '../../../../../Components/Helper'
import Popup from '../../../../../ReusableFunctions/Popup'
import Modal from '../../../../../ReusableComponents/Modal'
import InputField from '../../../../../ReusableComponents/InputField'
import Form from '../../../../../ReusableComponents/Form'
import { taxPercentageValidation } from '../../../../../utils/inputValidations'
import Loading from '../../../../../ReusableFunctions/Loader'
import { updateDspTax } from '../../../../../apis/users'

const EditTaxPercentage = ({ open, onClose, dsp, onUserUpdate }) => {

    const EditTax = async (dspDetails) => {
        if (dspDetails?.tax && dspDetails.id) {
            try {
                Loading.set(true)
                const res = await updateDspTax(dspDetails)
                onUserUpdate(res?.updatedDSP)
                Loading.set(false)
                Popup.alert("SUCCESS", "Tax Percentage Updated", "SUCCESS", onClose)
            } catch (e) {
                Loading.set(false)
                Popup.alert("Error", e || "something went wrong while changing password.", "ERROR");
            }
        }
    }


    return (
        <Modal
            header={'Edit Tax Percentage'}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "574px", height: "auto" }}
            divider={true}
            headingStyle={{ fontSize: "18px" }}
            iconSize={"18px"}
            headerContainerStyle={{ padding: '20px 40px' }}
        >
            <Form
                onSubmitForm={(data) => {
                    const { tax } = data;
                    EditTax({ tax, id: dsp.id });
                }}
                style={{ padding: "15px 40px 20px", display: "flex", flexDirection: "column", gap: "1.1rem" }}
            >
                {(onSubmit) =>
                    <>
                        <InputField
                            label={"Tax percentage (%)"}
                            name={"tax"}
                            placeholder={"Enter tax percentage"}
                            required={false}
                            style={{ height: '51px', borderRadius: "8px", padding: '2px 15px' }}
                            inputStyle={{ fontSize: "16px" }}
                            validation={taxPercentageValidation}
                            labelStyle={{ paddingBottom: "7px", fontSize: '16px', color: '#3b3b3b', fontWeight: "400" }}
                            defaultValue={dsp?.tax || ''}
                        />
                        <div style={{ display: "flex", flexDirection: "row-reverse", gap: "15px" }}>
                            <Button
                                type={"submit"}
                                text="Update"
                                style={{ width: "110px", height: "40px", fontSize: '16px' }}
                                onClick={() => onSubmit()}
                            />
                            <Button
                                type={"button"}
                                onClick={() => { onClose() }}
                                text={"Cancel"}
                                isBtnNotActive={true}
                                style={{ width: "110px", height: "40px", fontSize: '16px' }}
                            />
                        </div>
                    </>
                }
            </Form>
        </Modal>
    )
}

export default EditTaxPercentage